module.exports = __webpack_public_path__ + "img/A58A0536_min.ba028726.jpg";